import { render, staticRenderFns } from "./ContactSettingsModal.vue?vue&type=template&id=6bd8f848&scoped=true&"
import script from "./ContactSettingsModal.vue?vue&type=script&lang=js&"
export * from "./ContactSettingsModal.vue?vue&type=script&lang=js&"
import style0 from "./ContactSettingsModal.vue?vue&type=style&index=0&id=6bd8f848&lang=scss&scoped=true&"
import style1 from "./ContactSettingsModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd8f848",
  null
  
)

export default component.exports